import React from 'react'
// Import PropTypes from 'prop-types'

// Components
import BaseSkeleton from 'antd/lib/skeleton'

export const Skeleton = (props) => {
  return <BaseSkeleton {...props} />
}

// Props
Skeleton.propTypes = {}

Skeleton.defaultProps = {}

export default Skeleton
